// @ts-nocheck
import _ from "lodash";
//import PubSub from "core/pubsub/pubsub-js.js";
//import PubSub from "PubSub";
import pubsub from "core/global/global";
import Loader from "core/loader/index";
//import { MetadataProvider } from "core/provider/index";
import Cache from "core/cache/index";
import CustomEvent from "core/customEvent";
import Helper from "core/helper/index";
import { default as Events } from "core/customEvent/index";
import FloatMessageBox from "core/messageBoxController/index";
import brushModule from "component/molecules/viewport/tools/annotation/brushTool/brushModule";
import { clearAll } from "component/toolManager/toolState.js";
/**
 * @description 입력받은 DICOM File handle을 이용해 DICOM 데이터를 파싱하고 Provider에 전달
 * @todo 초기화 메세지 전달 코드 및 에러 핸들러는 의존성 주입 코드로 실행되도록 수정 필요
 * @function BindDICOMSource
 * @param {Array<File>} files
 */
/**
 * 축상(axial) 영상인지. Auto 업로드 서버와 같은 기준으로, 행·열 방향(Image Orientation Patient)의
 * 외적(단면의 법선)이 Z 축과 거의 같아야 한다 (각 성분 오차 0.1 이내).
 * 방향 정보가 없으면 판단할 수 없으므로 축상이 아닌 것으로 본다.
 */
function isAxialSeries(series) {
  const r = series && series.rowCosines;
  const c = series && series.columnCosines;
  if (!r || !c || r.concat(c).some(v => !Number.isFinite(v))) {
    return false;
  }
  const normal = [
    r[1] * c[2] - r[2] * c[1],
    r[2] * c[0] - r[0] * c[2],
    r[0] * c[1] - r[1] * c[0]
  ];
  return (
    Math.abs(normal[0]) <= 0.1 &&
    Math.abs(normal[1]) <= 0.1 &&
    Math.abs(Math.abs(normal[2]) - 1) <= 0.1
  );
}

async function DICOMFileProvider(files, sarcopeniaMeasureStore) {
  _.forEach(files, file => {
    /**
     * 0. Check memory
     * @ref @site : https://stackoverflow.com/questions/23506064/how-do-you-detect-memory-limits-in-javascript
     */
    //if (Helper.File.getFileExtension(). file.type !== "DICOM") {
    if (Helper.File.getFileExtension(file.name) !== "dcm") {
      return;
    }
    const memoryLimit = performance.memory.jsHeapSizeLimit; // will give you the JS heap size
    const usedMemory = performance.memory.usedJSHeapSize; // how much you're currently using
    const allowMissSize = 50000000; //50MB
    if (usedMemory + allowMissSize >= memoryLimit) {
      /// Todo : 아래 코드는 의존성 주입으로 실행되도록 수정 필요
      const parameters = {
        title: "Warning",
        message: "Memory is Limited",
        buttonType: "OK",
        hasCloseButton: false,
        hasTodayOffButton: false
      };
      FloatMessageBox(parameters);
      //console.log("Alert : Memory is Limited");
    }
    //console.log("memoryLimit : " + memoryLimit / 1024 / 1024);
    //console.log("usedLimit : " + usedMemory / 1024 / 1024);
    ///
    /// 1. File handle 배열을 이용해 순차적으로 DICOM 파일을 읽고 파싱
    ///
    const reader = new FileReader();
    const fileHandle = file;
    reader.onload = () => {
      let arrayBuffer = reader.result;
      //var byteArray = new Uint8Array(arrayBuffer);
      try {
        ///
        /// 2. 읽어들인 파일 내용을 DICOM Loader에 전달하여 DICOM 정보 파싱
        ///

        /// Todo : 아래 코드는 의존성 주입으로 실행되도록 수정 필요
        pubsub.publish(Events.Messages.INIT_VIEWPORT, {});
        let dicomLoader = new Loader.LoaderDicom();
        // let test = dicomLoader_NS.readFile(arrayBuffer);
        // let dicomHeader = dicomLoader_NS.DicomDataList;
        // let dicomInfo = dicomHeader.element["0x00020000"];
        dicomLoader
          .parseFile(fileHandle.name, arrayBuffer)
          .then(function(data) {
            ///
            /// 3. 파싱한 DICOM 정보를 Provider에 전달
            ///
            let metadataCache = new Cache.Metadata();
            const seriesInstanceUID = data.seriesInstanceUID;
            const modality = data.modality;

            if (
              !Helper.Validator.isString(seriesInstanceUID) ||
              !Helper.Validator.isString(modality)
            ) {
              console.error(
                "DICOM Data Type is not correct : seriesInstanceUID or modality"
              );
              return;
            }
            // L3 분석은 축상(axial) 단면만 가능하다. 아니면 안내만 하고 지금 보던 영상은 그대로 둔다
            if (!isAxialSeries(data)) {
              FloatMessageBox({
                title: "Warning",
                message:
                  "Only axial images can be analyzed. Please upload an axial CT image.",
                buttonType: "OK",
                hasCloseButton: false,
                hasTodayOffButton: false
              });
              return;
            }
            sarcopeniaMeasureStore.cancelRequestMeasureSarcopenia();
            sarcopeniaMeasureStore.clear();

            brushModule.setters.clearVisibleSegmentation();
            brushModule.setters.clearImageBitmapdCache();
            clearAll();
            metadataCache.clear();
            metadataCache.add(seriesInstanceUID, modality, data);
            pubsub.publish(CustomEvent.Messages.REQUEST_SEND_TO_VIEWPORT, {
              modality,
              seriesInstanceUID,
              viewportIndex: 0
            });
            // let windowController = new WindowController();
            // windowController.openWindow(data.patientID);
            // //windowController.saveOnQueue(data.patientID, data);
            // windowController.saveOnQueue(data.patientID, file);
          })
          .catch(function(err) {
            /// Todo : 아래 코드는 의존성 주입으로 실행되도록 수정 필요
            console.error(err);
          });
      } catch (ex) {
        /// Todo : 아래 코드는 의존성 주입으로 실행되도록 수정 필요
        const parameters = {
          title: "Warning",
          message: "This data is not supported format",
          buttonType: "OK",
          hasCloseButton: false,
          hasTodayOffButton: false
        };
        FloatMessageBox(parameters);
        console.log("file reading was failed");
      }
    };
    /// Todo :  아래 코드는 의존성 주입으로 실행되도록 수정 필요
    reader.onabort = () => console.log("file reading was aborted");
    reader.onerror = () => console.log("file reading has failed");
    reader.readAsArrayBuffer(file);
  });
}

export default DICOMFileProvider;
